/* A small, one-time emphasis on selected benefit words. Paragraphs and controls stay still. */
(() => {
 if(window.PCReadingMotion)return;
 const observers=new Map();
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 function reveal(el){el.dataset.pcWordPlayed='true';el.classList.add('is-word-revealed');observers.get(el)?.disconnect();observers.delete(el)}
 function scan(scope=document){
   scope.querySelectorAll('[data-pc-word-reveal]:not([data-pc-word-init])').forEach(el=>{
     el.dataset.pcWordInit='true';
     if(reduced.matches||!('IntersectionObserver'in window)){reveal(el);return}
     const observer=new IntersectionObserver(entries=>{if(entries.some(x=>x.isIntersecting))reveal(el)},{threshold:.85,rootMargin:'0px 0px -12% 0px'});
     observers.set(el,observer);observer.observe(el);
   });
 }
 function remove(scope){for(const [el,observer]of observers)if(scope.contains(el)){observer.disconnect();observers.delete(el)}}
 document.addEventListener('shopify:section:load',e=>scan(e.target));
 document.addEventListener('shopify:section:unload',e=>remove(e.target));
 reduced.addEventListener('change',()=>{if(reduced.matches)for(const el of observers.keys())reveal(el)});
 window.PCReadingMotion={scan};scan();
})();
